
import { defineComponent, PropType, ref } from 'vue'
import { BaseValidation } from '@vuelidate/core'

export default defineComponent({
  setup() {
    const focus = ref('')
    return { focus }
  },
  props: {
    label: { type: String, required: false },
    vuelidate: { type: Object as PropType<BaseValidation>, required: false },
    modelValue: { type: String, required: false },
    type: { type: String, required: false }
  },
  emits: ['update:modelValue'],
  methods: {
    onValueChanged(event: string) {
      this.$emit('update:modelValue', event)
    }
  }
})
